<template>
  <div class="competition-form" id="competition-form">

    <transition name="fade" mode="out-in">

      <div class="step1" v-if="step === 0" key="1">
        <div class="container">
          <div class="progress-steps">
            <span class="active">1</span>
            <span>2</span>
            <span>3</span>
          </div>
          <h2>WHICH ARTWORK WOULD YOU LOVE TO WIN?</h2>
          <h6 class="hint-text">PLEASE SELECT ONE OPTION AND CLICK NEXT</h6>

          <div class="artworks-carousel">
            <carousel :perPageCustom="[[0, 1], [767, 2], [992, 2], [1024, 4]]" :mouse-drag="true"
              :navigationEnabled="true">
              <slide v-for="art in artworkData" :key="art.name">
                <div :class="art.name === selectedArt ? 'artwork selected' : 'artwork'">
                  <img :src="art.img" alt="art1">
                  <h5>{{ art.name }}</h5>
                  <p class="desc">{{ art.desc }}<br>{{ art.size }}</p>
                  <h5 class="price">{{ art.price }}</h5>
                  <button class="btn" @click="selectArt(art.name)">{{ art.name === selectedArt ? 'SELECTED' : 'SELECT'
                  }}</button>
                </div>
              </slide>
            </carousel>
          </div>
          <button class="btn next btn-light title-font" @click="gotoStep(1)" :disabled="!selectedArt">NEXT
            <i class="fa fa-arrow-right d-md-inline-block"></i>
          </button>
          <p class="disclaimer">Competition period from 1<sup>st</sup> March to 1<sup>st</sup> May 2024. For full terms and conditions <a href="../wp-content/themes/audreyfinearts/src/uploads/audrey-fine-art-anthony-ricciardi-competition-terms-and-conditions.pdf">click here</a>.</p>
        </div>

      </div>

      <div class="step2" v-if="step === 1" key="2">
        <div class="container">
          <div class="progress-steps">
            <span>1</span>
            <span class="active">2</span>
            <span>3</span>
          </div>
          <h2>TELL US WHY YOU’D LOVE TO WIN AN ANTHONY RICCIARDI PIECE</h2>
          <div class="form">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Name" name="name" v-model="name">
                </div>
              </div>
              <div class="col-md-6 mt-4 mt-md-0">
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Postcode" name="postcode" v-model="postcode">
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <div class="form-group">
                  <input type="email" class="form-control" placeholder="Email Address" name="email" v-model="email">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <h6>In 25 words or less, tell us why you would love to own an Anthony Ricciardi painting?</h6>
                  <textarea class="form-control" rows="4" placeholder="Answer here..." name="answer"
                    v-model="answer"></textarea>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-light next title-font" @click="gotoStep(2)" :disabled="!validForm">NEXT
            <i class="fa fa-arrow-right d-md-inline-block"></i>
          </button>

        </div>
      </div>

      <div class="step3" v-if="step === 2" key="3">
        <div class="container">
          <div class="progress-steps">
            <span>1</span>
            <span>2</span>
            <span class="active">3</span>
          </div>
          <h2>LASTLY, WE HAVE A FEW SIMPLE QUESTIONS TO COMPLETE YOUR ENTRY</h2>

          <div class="question" v-for="(value, index) in questions" :key="index">
            <h6>{{ value.question }}</h6>
            <div class="row">
              <div class="col-6 mt-4 mt-md-0" v-for="(answer, i) in value.answers" :key="i"><button
                  :class="answer.selected ? 'btn selected p-3' : 'btn p-3'" @click="setAnswer(index, i)">{{ answer.value
                  }}</button></div>
            </div>
          </div>
          <button class="btn btn-light next title-font submit" @click="submit" :disabled="!validQuestions">SUBMIT</button>
        </div>

      </div>

      <div class="submitted" v-if="step === 3" key="4">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 mb-lg-0 mb-4">
              <span class="badge d-md-inline-block d-lg-none"> 🎉 WOO YOU'RE IN THE RUNNING!</span>
              <img :src="'../wp-content/themes/audreyfinearts/images/thankyou-img.png'" alt="thank-you">
            </div>
            <div class="col-lg-6 content">
              <span class="badge d-none d-lg-inline-block">
                <h4 class="m-0">🎉 WOO YOU'RE IN THE RUNNING!</h4>
              </span>
              <h2>Want bonus entries to increase your chances of winning!?</h2>
              <p>1. Capture a story using our filter inspired by Anthony Riccairdi</p>
              <p>2. Tag us <strong>@audreyfineart</strong> and use the hashtag <strong>#FOLLOWTHEHEART</strong></p>
              <p>3. Share it on your story, and make sure you’re on public so we can see</p>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Instagram username" name="ig_name" v-model="ig_name">
              </div>
              <button class="btn btn-light title-font" :disabled="!ig_name" 
                  @click="useFilter">USE THE FILTER <img
                  :src="'../wp-content/themes/audreyfinearts/images/filter-icon.svg'" alt="smile icon"></button>
            </div>
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>


<script>
import { Carousel, Slide } from 'vue-carousel';


export default {
  name: 'app',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      step: 0,
      selectedArt: '',
      name: '',
      email: '',
      postcode: '',
      answer: '',
      ig_name: '',
      insert_id: null,
      artworkData: [
        {
          name: 'Amy Winehouse',
          desc: 'Mixed media on Canvas',
          size: '105 x 83 cm',
          price: '$5,000',
          img: '../wp-content/themes/audreyfinearts/images/artwork/art1.jpg',
        },
        {
          name: 'Champion Mindset',
          desc: 'Mixed media on Canvas',
          size: '105 x 105 cm',
          price: '$5,000',
          img: '../wp-content/themes/audreyfinearts/images/artwork/art2.jpg',
        },
        {
          name: 'Brigette Bardot',
          desc: 'Mixed media on Canvas',
          size: '105 x 83 cm',
          price: '$5,000',
          img: '../wp-content/themes/audreyfinearts/images/artwork/art3.jpg',
        },
        {
          name: 'Mickey & Minnie',
          desc: 'Mixed media on Canvas',
          size: '105 x 83 cm',
          price: '$5,000',
          img: '../wp-content/themes/audreyfinearts/images/artwork/art4.jpg',
        },
        {
          name: 'Audrey',
          desc: 'Mixed media on Canvas',
          size: '105 x 83 cm',
          price: '$5,000',
          img: '../wp-content/themes/audreyfinearts/images/artwork/art5.jpg',
        },
        {
          name: 'Jordan',
          desc: 'Mixed media on Canvas',
          size: '105 x 83 cm',
          price: '$5,000',
          img: '../wp-content/themes/audreyfinearts/images/artwork/art6-1.jpg',
        },
        {
          name: 'Superman',
          desc: 'Mixed media on Canvas',
          size: '105 x 83 cm',
          price: '$5,000',
          img: '../wp-content/themes/audreyfinearts/images/artwork/art7.jpg',
        },

      ],
      questions: [
        {
          question: 'Have you purchased art before?',
          answers: [
            { value: 'Yes, I love art', selected: false },
            { value: 'Not yet', selected: false },
          ]
        },
        {
          question: 'Would you consider yourself an art collector?',
          answers: [
            { value: 'I’d say so', selected: false },
            { value: 'I hope to be', selected: false },
          ]
        },
        {
          question: 'Are you interested in any other pieces from our gallery?',
          answers: [
            { value: 'Definitely', selected: false },
            { value: 'MAYBE', selected: false },
          ]
        }
      ],
    }
  },
  props: {

  },
  computed: {
    validForm() {
      return this.name && this.email && this.postcode && this.answer;
    },

    validQuestions() {
      let valid = true
      this.questions.forEach(question => {
        if (!question.answers.find((answer) => answer.selected === true)) {
          valid = false;
        }
      });
      return valid;
    },

    getQuestionsAnswers() {
      let arr = [];
      this.questions.forEach(question => {
        arr.push(`${question.question}: ${question.answers.find((answer) => answer.selected === true).value}`)
      })
      return arr;
    }

  },
  mounted() {

  },
  methods: {
    gotoStep(step) {
      window.scrollTo(0, document.getElementById('competition-form').offsetTop);
      this.step = step;
    },
    selectArt(art) {
      this.selectedArt = art;
    },
    setAnswer(index, i) {
      this.questions[index].answers.forEach((answer, ind) => {
        answer.selected = (ind === i) ? true : false;
      })
    },
    hideSections() {
      document.querySelectorAll('.hide-on-submit').forEach((elem) => elem.style.display = 'none');
      document.body.classList.add('changed');
    },
    submit() {
      const formData = new FormData();
      formData.append('action', 'submit_competition_form'); // AJAX action
      formData.append('nonce', comp_form.nonce);
      formData.append('artwork', this.selectedArt);
      formData.append('name', this.name);
      formData.append('postcode', this.postcode);
      formData.append('email', this.email);
      formData.append('answer', this.answer);
      formData.append('questions', JSON.stringify(this.getQuestionsAnswers));

      fetch(comp_form.ajax_url, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            this.insert_id = data.id;
            this.hideSections();
            this.gotoStep(3);
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
    useFilter() {

      const formData = new FormData();
      formData.append('action', 'submit_competition_form_ig_username'); // AJAX action
      formData.append('nonce', comp_form.nonce);
      formData.append('id', this.insert_id);
      formData.append('ig_name', this.ig_name);
    

      fetch(comp_form.ajax_url, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            console.log('open filter link');
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }

  },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}

.artwork img {
  width: 100%;
}


.artwork {
  padding: 0 15px;
}

.artworks-carousel {
  margin: 0 -15px;
}

@media (max-width: 767px) {
  .artworks-carousel {
    position: relative;
    width: 100vw;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
  }
}

.step1,
.step3 {
  background-color: #191919;
}

.step2 {
  background-color: #232323;
}

.submitted {
  background: #feee55;
}

.submitted img {
  max-width: 500px;
  width: 100%;
}


.submitted .badge {
  background: #fff;
  color: #000;
  font-weight: 900;
  padding: 10px 30px;
  border-radius: 25px;
  margin-bottom: 35px;
  text-transform: uppercase;
}

.submitted .content h2 {
  text-transform: uppercase;
  color: #000;
  margin-bottom: 25px;
}

.submitted .content p {
  color: #000;
  margin-bottom: 10px;
}

.submitted .content .btn {
  margin-top: 25px;
  box-shadow: 0 9px 22px 0 rgba(0, 0, 0, 0.12);
}

.submitted .content .btn img {
  width: 20px;
  position: relative;
  top: -3px;
}

.disclaimer {
    margin-bottom: 0;
    margin-top: 20px;
}

.disclaimer a{
    color:#fff;
    text-decoration: underline;
    font-family: program,sans-serif;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0;
}

</style>


// WEBPACK FOOTER //
// src/App.vue